import script from "./DeviceShareModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceShareModal.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceShareModal.vue?vue&type=style&index=0&id=8132c782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8132c782"]])

export default __exports__